<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Gallegos">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Gallegos"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. Miguel Angel Gallegos Robles</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> garoma64@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 1
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>Desarrollo Agrícola Sustentable, Consolidado.</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            ING. AGRÓNOMO FITOTECNISTA (1988)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIVIVERSIDAD AUTONOMA AGRARIA ANTONIO NARRO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>FITOMEJORAMIENTO (1993)</li>
                            <p>UAAAN / FAC. DE AGRIC. Y ZOOTECNIA</p>
                            <li>AGR. ORGANICA SUSTENTABLE (2001)</li>
                            <p>UAAAN / UJED</p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>BIOTECNOLOGIA (2008)</li>
                            <p>
                                FAC. DE CIENCIAS BIOLOGICAS
                                <br>
                                UANL
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>Biología Molecular</li>
                            <li>Genética</li>
                            <li>Inocuidad Agrícola</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/gallegos.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'ARTÍCULO: Ramírez-Aragón, M.G.; V.J. Borroel-García, L. Salas-Pérez, J.D. López-Martínez, M.A. Gallegos-Robles, y H.I. Trejo-Escareño. ÁCIDO ROSMARÍNICO, FENÓLICOS TOTALES Y CAPACIDAD ANTIOXIDANTE EN TRES VARIEDADES DE Ocimum basilicum L. CON DIFERENTES DOSIS DE POTASIO. Polibotánica. Núm. 47: 89-98',
                    publicacion: 2019,
                },
                {
                    numero: 2,
                    titulo: 'ARTÍCULO: Magdalena GALINDO-GUZMÁN, Erika FLORES-LOYOLA, Miguel Ángel GALLEGOS-ROBLES, Manuel FORTIS-HERNÁNDEZ, Uriel FIGUEROA-VIRAMONTES y Cirilo VÁZQUEZ-VÁZQUEZ. ACETILCOLINESTERASA DE Eisenia foetida COMO INDICADOR DE CONTAMINACIÓN POR PLAGUICIDAS ORGANOFOSFORADOS. Rev. Int. Contam. Ambie. 35 (1) 115-124',
                    publicacion: 2019,
                },
                {
                    numero: 3,
                    titulo: 'ARTÍCULO: Rosa Maria Estrada-Loera, Miguel Ángel Gallegos-Robles*, Ignacio Orona-Castillo, José Luis García-Hernández, Jorge Alberto Osuna-García, Roberto Sánchez-Lucio, Juan Luis Ríos-Plaza, Cirilo Vázquez-Vázquez. PREVALENCIA DE BACTERIAS PATÓGENAS EN MANGO (Mangifera indica L) CV. TOMMY ATKINS. Biotecnia / XXI (1): 5-12',
                    publicacion: 2019,
                },
                {
                    numero: 4,
                    titulo: 'ARTÍCULO: Pablo Preciado-Rangel; Lilia Salas-Pérez; Miguel Á Gallegos-Robles; Francisco H Ruiz-Espinoza; Alma V Ayala-Garay; Manuel Fortis-Hernández; Bernardo Murillo-Amador. Increasing doses of potassium increases yield and quality of muskmelon fruits under greenhouse. Hortic. bras., Brasília, v.36, n.2: 175-179',
                    publicacion: 2018,
                },
                {
                    numero: 5,
                    titulo: 'ARTÍCULO: José Ángel Maraña-Santacruz, Edmundo Castellanos-Pérez, Cirilo Vázquez-Vázquez, Juan José Martínez-Ríos, Héctor Idilio Trejo-Escareño, Miguel Ángel Gallegos-Robles. Solarized manure and two irrigation methods on fruit yield of jalapeno chili (Capsicum annuum L. var. annuum). Rev. FCA UNCUYO. 50 (2): 105-117.',
                    publicacion: 2018
                },
                {
                    numero: 6,
                    titulo: 'ARTÍCULO: Radames Trejo Valencia, Ludy Sánchez Acosta, Manuel Fortis Hernández, Pablo Preciado Rangel, Miguel Ángel Gallegos Robles, Rocío del Carmen Antonio Cruz and Cirilo Vázquez Vázquez. Effect of Seaweed Aqueous Extracts and Compost on Vegetative Growth, Yield, and Nutraceutical Quality of Cucumber (Cucumis sativus L.) Fruit. Agronomy. 8, 264: 1-13',
                    publicacion: 2018
                },
                {
                    numero: 7,
                    titulo: 'ARTÍCULO: Manuel Fortis-Hernández; Pablo Preciado-Rangel; Miguel A Segura-Castruita; Leonel Mendoza T; Miguel A Gallegos-Robles; José L García Hernández; Cirilo Vásquez-Vásquez. Changes in nutraceutical quality of tomato under different organic substrates. Hortic. bras., Brasília, v.36, n.2: 180-185.',
                    publicacion: 2018
                },
                {
                    numero: 8,
                    titulo: 'ARTÍCULO: José Ángel Maraña Santacruz, Edmundo Castellanos Pérez, Cirilo Vázquez Vázquez, Juan José Martínez Ríos, Héctor Idilio Trejo Escareño, Miguel Ángel Gallegos Robles e Ignacio Orona Castillo. Rendimiento de chile jalapeño con lixiviado de lombriz con dos métodos de riego. Terra Latinoamericana 36: 345-354.',
                    publicacion: 2018
                },
                {
                    numero: 9,
                    titulo: 'ARTÍCULO: Uriel González-Salas, Miguel Ángel Gallegos-Robles*, Cirilo Vázquez-Vazquez, José Luis García-Hernandez, Manuel Fortis-Hernández, Sarai Shesareli Mendoza-Retana. Productividad de genotipos de maíz forrajero bajo fertilización orgánica y propiedades físico-químicas del suelo. Rev. Mex. Cienc. Agríc.  vol. esp. núm. 20: 4331-4341.',
                    publicacion: 2018
                },
                {
                    numero: 10,
                    titulo: 'ARTÍCULO: Tomás Juan Álvaro Cervantes Vázquez, Manuel Fortis Hernández, Héctor Idilio Trejo Escareño, Cirilo Vázquez Vázquez, Miguel Ángel Gallegos Robles, José Luis García Hernández. Fertilización química y orgánica en la producción de sandía en el norte de México. Rev. Mex. Cienc. Agríc.  vol. esp. núm. 20: 4263-4275.',
                    publicacion: 2018
                },
                {
                    numero: 11,
                    titulo: 'ARTÍCULO: María A. Ávalos de la Cruz, Uriel Figueroa Viramontes, José L. García Hernández, Cirilo Vázquez Vázquez, Miguel A. Gallegos Robles e Ignacio Orona Castillo. Bioinoculantes y Abonos Orgánicos en la Producción de Maíz Forrajero. Nova Scientia. Nº 20, Vol. 10 (1): 170 - 189',
                    publicacion: 2018
                },
                {
                    numero: 12,
                    titulo: 'ARTÍCULO: Tania Lizzeth Guzmán-Silos, Miguel Ángel Gallegos-Robles*, Juan Ramón Esparza-Rivera, Cirilo Vázquez-Vázquez, Uriel Gonzáles-Salas, J. Guadalupe Luna-Ortega, Anselmo González-Torres. Parámetros de estabilidad en híbridos de girasol con alto contenido de oleico. Ecosistemas y Recursos Agropecuarios. 4(11): 213-222.',
                    publicacion: 2017
                },
                {
                    numero: 13,
                    titulo: 'ARTÍCULO: Sarai S. Mendoza-Retana, Miguel A. Gallegos-Robles*, Uriel González-Salas, José L. García-Hernández, Manuel Fortis-Hernández, Cirilo Vázquez-Vázquez y Héctor I. Trejo-Escareño. Polimorfismos del gen ob en bovinos de raza Holstein en la Comarca Lagunera, México. Nova Scientia. Nº 19, Vol. 9 (2): 372-392.',
                    publicacion: 2017
                },
                {
                    numero: 14,
                    titulo: 'ARTÍCULO: José Apolinar Ramírez-Ibarra, Enrique Troyo-Dieguez, Pablo Preciado-Rangel, Manuel Fortis-Hrnández, Miguel Ángel Gallegos-Robles, Cirilo Vázquez-Vázquez, Juan Luis Ríos Plaza, José Luis García-Hernández. Diagnóstico de nutrimento compuesto e interacciones nutrimentales en chile jalapeño (Capsicum Annuum L) en suelos semiáridos. Ecosistemas y Recursos Agropecuarios. 4(11): 233-242.',
                    publicacion: 2017
                },
                {
                    numero: 15,
                    titulo: 'ARTÍCULO: J.L. Ríos-Plaza, R.D. Valdez-Cepeda, C. Vázquez-Vázquez, I. Orona-Castillo, M.A. Gallegos-Robles, J.A. Ramírez-Ibarra y J.L. García-Hernández. Normas nutrimentales preliminares para un cultivar criollo de Capsicum annuum con base en la técnica de diagnóstico de nutrimento compuesto. ITEA. Vol. 113 (3), 216-227.',
                    publicacion: 2017
                },
                {
                    numero: 16,
                    titulo: 'ARTÍCULO: Mario García Carrillo, J. Guadalupe Luna Ortega, Anselmo González Torres, Alberto González Zamora, Miguel Ángel Gallegos Robles, Cirilo Vázquez Vázquez, María Gabriela Cervantes Vázquez y Uriel González Salas. Relación de díeldrin y propiedades del suelo en la Comarca Lagunera, México. Rev. Mex. Cienc. Agríc. Vol.8  Núm.8: 1691-1703.a',
                    publicacion: 2017
                },
                {
                    numero: 17,
                    titulo: 'ARTÍCULO: Anselmo González-Torres, J Guadalupe Luna-Ortega, Miguel A Gallegos-Robles, José L García Hernández, Pablo Preciado-Rangel, Cesar Guerrero-Guerrero, Mario García-Carrillo. Aptitud combinatoria y heterosis en híbridos de líneas endogámicas de maíz. Ecosistemas y Recursos Agropecuarios. 4(11): 223-232.',
                    publicacion: 2017
                },
                {
                    numero: 18,
                    titulo: 'ARTÍCULO: Rosa I. Ramírez-Chavez, José D. López-Martínez, Enrique Troyo-Dieguez, Miguel A. Gallegos-Robles, Cirilo Vázquez-Vázquez, José A. Ramírez-Ibarra, José L. García-Hernández. Determinación preliminar de normas e interacciones nutrimentales en chile ancho (Capsicum annuum L) en la Comarca Lagunera. Nova Scientia. 8(2): 198-218.',
                    publicacion: 2016
                },
                {
                    numero: 19,
                    titulo: 'ARTÍCULO: Enrique Salazar Sosa, Hector I Trejo Escareno, Jesus Luna Anguiano, Miguel A. Gallegos Robles, Enrique Salazar Melendez, Jose Dimas Lopez Martinez and Orona Castillo Ignacio. Long Term of Cattle Manure Amendments and Its Impact on Triticale (X. Triticosecale Wittmack) Production and Soil Quality. Adv Crop Sci Tech. 4(3): 2-5.',
                    publicacion: 2016
                },
                {
                    numero: 20,
                    titulo: 'ARTÍCULO: Sarai Monserrat Cueto-Medina, Antonio Castillo-Martínez, Sergio Hernández-Rodríguez, Miguel Ángel Gallegos-Robles, Francisco Javier Sánchez-Ramos, Aldo Iván Ortega-Morales. PRESENCIA DE Salmonella sp. EN CUCARACHA AMERICANA Periplaneta americana L. (BLATTODEA: BLATTIDAE) EN TORREÓN, COAHUILA, MÉXICO. Entomología Mexicana Vol. 2: 762-766.',
                    publicacion: 2015
                },
                {
                    numero: 21,
                    titulo: 'ARTÍCULO: Antonio CASTILLO- MARTÍNEZ, Sarai M. CUETO-MEDINA, Sergio HERNÁNDEZ-RODRÍGUEZ, Miguel Ángel GALLEGOS-ROBLES, María Teresa VALDÉS-PEREZGASGA, Francisco Javier SÁNCHEZ-RAMOS & Aldo I. ORTEGA-MORALES. DETECCIÓN DE RICKETTSIA SP. EN LA GARRAPATA CAFÉ DEL PERRO RHIPICEPHALUS SANGUINEUS (ACARI: IXODIDAE) EN MATAMOROS, COAHUILA, MÉXICO Acta Zoológica Mexicana. 31(1): 80-83.',
                    publicacion: 2015
                },
                {
                    numero: 22,
                    titulo: 'ARTICULO: Cirilo Vazquez-Vazquez, Miguel Angel Gallegos-Robles*, Enrique Salazar-Sosa, Ignacio Orona-Castillo, José Luis Garcia-Hernandez, Hector Idilio Trejo-Escareño and Sarai Shesarely Mendoza-Retana. Manure Solarization from Cattle, Goat and Poultry and its Effect on Survival of Salmonella spp. JOURNAL OF PURE AND APPLIED MICROBIOLOGY, March 2015. Vol. 9(1), p. 151-158.',
                    publicacion: 2015
                },
                {
                    numero: 23,
                    titulo: 'ARTICULO: Miguel Ángel Gallegos-Robles, José Luis García-Hernández, J. Guadalupe Luna-Ortega, José Dimas López Martínez, Ignacio Orona-Castillo, Enrique Salazar-Sosa, Anselmo González-Torres. OBTENCIÓN DE HIBRIDOS DE MAÍZ PARA GRANO EN LA COMARCA LAGUNERA Y AGUASCALIENTES, MÉXICO. Ecosistemas y Recursos Agropecuarios. 2(6): 245-254.',
                    publicacion: 2015
                },
                {
                    numero: 24,
                    titulo: 'ARTICULO: Alberto González-Zamora, Erick Sierra-Campos, Rebeca Pérez-Morales, Cirilo Vázquez-Vázquez, Miguel A. Gallegos-Robles, José D. López-Martínez, and José L. García-Hernández. Measurement of Capsaicinoids in Chiltepin Hot Pepper: A Comparison Study between Spectrophotometric Method and High Performance Liquid Chromatography Analysis. Journal of Chemistry. 2015: 1-10.',
                    publicacion: 2015
                },
                {
                    numero: 25,
                    titulo: 'ARTICULO: Rowland M. Shelley, Ancelmo Orona Espino, Miguel Ángel Gallegos Robles. A contribution on the Middle American milliped family Rhachodesmidae (Polydesmida: Leptodesmidea: Rhachodesmoidea): description of Tiphallus torreon . sp., the first species from Coahuila, Mexico. Insecta Mundi. Vol. 0423: 1-10.',
                    publicacion: 2015
                },
                {
                    numero: 26,
                    titulo: 'ARTICULO: Miguel A. Gallegos-Robles, Alberto Morales-Loredo, Genoveva Álvarez-Ojeda, Jesús Vázquez-Navarrete, Sixto Velarde-Félix, Pina Fratamico and José L. García-Hernández. Genetic Diversity Demonstrated by Pulsed Field Gel Electrophoresis of Salmonella enterica Isolates Obtained from a Bell Pepper Production System and Other Sources in Mexico. JOURNAL OF PURE AND APPLIED MICROBIOLOGY, October 2014. Vol. 8(5), p. 3599-3607.',
                    publicacion: 2014
                },
                {
                    numero: 27,
                    titulo: 'ARTICULO: Cesar Guerrero Guerrero, Miguel A. Gallegos Robles, José Guadalupe Luna Ortega, Ignacio Orona Castillo, Cirilo Vázquez Vázquez, Mario García Carrillo, Alejandro Moreno Resendez, Anselmo González Torres. Combining Ability and Heterosis in Corn Breeding Lines to Forage and Grain. American Journal of Plant Sciences, 2014, 5, 845-85',
                    publicacion: 2014
                },
                {
                    numero: 28,
                    titulo: 'ARTICULO: M.A. GALLEGOS-ROBLES, A. MORALES-LOREDO, G. ALVAREZ-OJEDA, J.A. OSUNA-GARCIA, I.O. MARTINEZ, L.H.MORALES-RAMOS, AND P. FRATAMICO. PCR Detection and Microbiological Isolation of Salmonella spp. from Fresh Beef and Cantaloupes. JOURNAL OF FOOD SCIENCE, 2009. Vol. 74, Nr. 1: 37-40.',
                    publicacion: 2009
                },
                {
                    numero: 29,
                    titulo: 'ARTICULO: MIGUEL A. GALLEGOS-ROBLES, ALBERTO MORALES-LOREDO, GENOVEVA ALVAREZ-OJEDA, ADRIAN VEGA-P., YAZMIN CHEW-M., SIXTO VELARDE, AND PINA FRATAMICO. Identification of Salmonella Serotypes Isolated from Cantaloupe and Chile Pepper Production Systems in Mexico by PCR–Restriction Fragment Length Polymorphism. Journal of Food Protection, Vol. 71, No. 11, 2008, Pages 2217–2222.',
                    publicacion: 2008
                },
                {
                    numero: 30,
                    titulo: 'ARTICULO: José Dimas López-Martínez, Miguel Gallegos Robles, J. Santos Serrato C., Ricardo D. Valdez Cepeda y Enrique Martínez-Rubín. Producción de algodonero transgénico fertilizado con abonos orgánicos y control de plagas. Terra Latinoamericana. 20: 321-327.',
                    publicacion: 2008
                }
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'Análisis del efecto de PGPR halotolerantes sobre el comportamiento agronómico del tomate en malla sombra. Financiado por UJED. 2017-2020. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Polimorfismos del gen ob en bovinos de raza Holstein en la Comarca Lagunera, México. Financiado por UJED. 2018. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Rendimiento, calidad bioquímica e inocuidad microbiológica en el cultivo de tomate producido con estiércol bovino. Financiado por UJED. 2017. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Respuesta del cultivo de tomate al estiércol bovino y a la aplicación de potasio en tres dosis. Financiado por UJED. 2017. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Producción de forraje de tres híbridos de maíz (Zea mays L.) bajo diferentes dosis de estiércol solarizado y composta. Financiado por UJED. 2016. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'IDENTIFICACIÓN DE PUNTOS CRITICOS DE CONTAMINACIÓN MICROBIANA EN LA CADENA PRODUCTIVA DE TOMATE. Financiado por UJED. 2016. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Efectos genéticos en características fisiológicas, valor nutritivo y produción de líneas contrastantes de triticale forrajero. Financiado por UJED. 2016. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'SOLARIZADO DE ESTIÉRCOL Y EL EFECTO EN BACTERIAS ENTEROPATOGENAS. 2015. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'EFECTO DE UN CULTIVO DE LEVADURAS ENZIMATICAMENTE HIDROLIZADAS EN EL COMPORTAMIENTO PRODUCTIVO Y LA INCIDENCIA DE DIARREAS INFECCIOSAS EN BECERRAS HOLSTEIN LACTANTES. Financiado por UJED y Empresa TANSA y Vi-Cor. 2015. Responsable.',
                    tipo: 'INTERNO-EXTERNO'
                },
                {
                    nombre: 'Presencia de Salmonella spp en insumos alimenticios avícolas y caracterización molecular de la resistencia a antibióticos. 2014. Financiado por UJED. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'ESTADO DE INOCUIDAD DEL SISTEMA PRODUCTIVO DE TOMATE (Lycopersicum esculentum Mill) EN RELACIÓN A LA PRESENCIA DE MICROORGANISMOS PATÓGENOS. Financiado por UJED. 2014. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Validación muestras de empresas para diagnosticar la presencia de Salmonella, E. coli y coliformes fecales de acuerdo a los Sistemas de Reducción de Riesgos de Contaminación emitidos por SENASICA. 2013. Financiado por SESAVEDAC. Responsable.',
                    tipo: 'EXTERNO'
                },
                {
                    nombre: 'DETERMINACIÓN DE CARGA MICROBIANA Y CARACTERIZACIÓN MOLECULAR DE CRYPTOSPORIDIUM SPP. Y SALMONELLA SPP. EN TRES ABONOS ORGÁNICOS SOLARIZADOS. Financiado por UJED. 2012. Responsable.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Evaluación y selección de híbridos de girasol (Helianthus annuus L.) Alto oleico en el estado de Durango. 2010. Financiado por CONACYT-UAEM. Responsable.',
                    tipo: 'EXTERNO'
                }
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
